import { Injectable } from "@angular/core";
import { QueryEntity } from "@datorama/akita";
import { isDefined } from "@recursyve/nice-ts-utils";
import { Observable } from "rxjs";
import { TicketStatusesEnum } from "../../../../../../api/acl/ticket/enums/ticket-statuses.enum";
import { Tickets } from "../../../../../../api/acl/ticket/models/tickets.model";
import { BatchNumberUtils } from "../../../../../../utils/batch-number.utils";
import { TicketListToDeliverState, TicketListToDeliverStore } from "./ticket-list-to-deliver.store";

@Injectable()
export class TicketListToDeliverQuery extends QueryEntity<TicketListToDeliverState> {
    constructor(store: TicketListToDeliverStore) {
        super(store);
    }

    public selectSearch(): Observable<string> {
        return this.select("searchTerm");
    }

    public selectTickets(searchTerm = ""): Observable<Tickets[]> {
        return this.selectAll({
            filterBy: ticket =>
                ticket.status === TicketStatusesEnum.ToDeliver && this.matchSearch(ticket, searchTerm),
            sortBy: BatchNumberUtils.compareTicketsByBatchNumber
        });
    }

    private matchSearch(ticket: Tickets, searchTerm: string): boolean {
        if (!isDefined(searchTerm) || searchTerm.length === 0) {
            return true;
        }

        const formattedSearchTerm = searchTerm.toLocaleLowerCase();

        return (
            ticket.batchNumber?.toLocaleLowerCase().includes(formattedSearchTerm) ||
            ticket.client?.name?.toLocaleLowerCase().includes(formattedSearchTerm) ||
            ticket.client?.city?.toLocaleLowerCase().includes(formattedSearchTerm) ||
            ticket.clientId?.toLocaleLowerCase().includes(formattedSearchTerm) ||
            ticket.preparedBy?.fullName?.toLocaleLowerCase().includes(formattedSearchTerm)
        );
    }
}
